export default "__VITE_PUBLIC_ASSET__76ec2475__"